import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-user-management-add-user',
  templateUrl: './company-user-management-add-user.component.html',
  styleUrls: ['./company-user-management-add-user.component.css']
})
export class CompanyUserManagementAddUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
